import { getEnvVariable } from "../util/environment.js";

//#region ../base/tests/mock.ts
const MOCK_URLS = {
	success: "http://SUCCESS",
	error: "http://ERROR"
};
function isMockUrl(url) {
	return Boolean(getEnvVariable("TEST") && Object.values(MOCK_URLS).includes(url));
}

//#endregion
export { isMockUrl };